























import Vue from 'vue'
import dayjs from 'dayjs'
import FullModalLayout from '@/components/modal/basics/FullModal/FullModalLayout.vue'
import FullModalHeaderTitle from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderTitle.vue'
import GHeaderBackButton from '@/components/globals/GHeader/GHeaderBackButton.vue'
import SearchProgramForm, { FormValues } from './SearchProgramForm.vue'
import { Keys } from '@/store/modules/search/getters'
import {
  updateSearchConditions,
  loadConditions,
  saveConditions,
} from '@/store/modules/search/types'
import { searchProgramCount, SearchCountParams } from '@/core/Programs'
import { Meta } from '@/tools/page'
import { SearchState } from '@/store/modules/search'

const PAGE_TITLE = 'プログラムを検索・予約する'
const PAGE_META: Meta[] = [
  {
    name: 'description',
    content:
      'GYYM(ジーム)は様々なジムのプログラムを都度利用できるサービスです。全国のジムやプログラムの情報からさまざまな条件を指定して検索！豊富なプログラム情報からあなたにピッタリのプログラムを見つけましょう。',
  },
]

export default Vue.extend({
  name: 'SearchProgramModal',
  components: {
    SearchProgramForm,
    FullModalLayout,
    GHeaderBackButton,
    FullModalHeaderTitle,
  },
  data() {
    return {
      resultCount: 0,
      isLoadingResultCount: false,
      isDirectAccess: false,
      isSubmitted: false,
      prevPageTitle: '',
      prevPageMeta: [] as Meta[],
    }
  },
  computed: {
    searchConditions() {
      const conditions: SearchState['conditions'] =
        this.$store.getters[Keys.GET_SEARCH_CONDITIONS]
      const [startTimeBeforeHour = '', startTimeBeforeMinute = ''] =
        conditions.startTimeBefore ? conditions.startTimeBefore.split(':') : []
      const [startTimeAfterHour = '', startTimeAfterMinute = ''] =
        conditions.startTimeAfter ? conditions.startTimeAfter.split(':') : []

      return {
        ...conditions,
        searchDates: conditions.searchDates
          .map((date) => {
            const d = dayjs(date)
            return d.isValid() ? d.format('YYYY-MM-DD') : null
          })
          .filter((d) => d) as string[],
        startTimeBefore: {
          hour: startTimeBeforeHour,
          minute: startTimeBeforeMinute,
        },
        startTimeAfter: {
          hour: startTimeAfterHour,
          minute: startTimeAfterMinute,
        },
      }
    },
  },
  beforeCreate() {
    this.$modal.push('SearchProgramModal')
  },
  beforeRouteEnter(to, from, next) {
    // @ts-ignore
    next((vm) => (vm.isDirectAccess = from.fullPath === '/'))
  },
  beforeRouteLeave(to, from, next) {
    // 戻るときに元のtitle/metaタグをセットする
    this.$setPageTitle(this.prevPageTitle, '')
    this.$setPageMeta(this.prevPageMeta)

    this.$modal.pop()
    next()
  },
  async created() {
    // 遷移前のtitle/metaタグ情報を取得しておく
    this.prevPageTitle = this.$getPageTitle()
    this.prevPageMeta = this.$getPageMeta()

    this.$setPageTitle(PAGE_TITLE)
    this.$setPageMeta(PAGE_META)

    // 永続化された検索状態を読み込む
    this.$store.commit(loadConditions())

    const params = this.convertFormValues(this.searchConditions)
    await this.fetchCount(params)
  },
  methods: {
    async fetchCount(params: SearchCountParams) {
      this.isLoadingResultCount = true
      const { count } = await searchProgramCount(params)
      this.resultCount = count
      this.isLoadingResultCount = false
    },
    convertFormValues(values: FormValues): SearchCountParams {
      return {
        ...values,
        searchDates: values.searchDates.map((d) =>
          dayjs(d).format('YYYY-MM-DD')
        ),
        startTimeBefore:
          values.startTimeBefore && values.startTimeBefore.hour
            ? `${values.startTimeBefore.hour}:${values.startTimeBefore.minute}`
            : undefined,
        startTimeAfter:
          values.startTimeAfter && values.startTimeAfter.hour
            ? `${values.startTimeAfter.hour}:${values.startTimeAfter.minute}`
            : undefined,
      }
    },
    onFormValuesChange(values: FormValues) {
      // フォームの値が変更されたら新しい検索結果件数を取得する
      const query = this.convertFormValues(values)
      this.fetchCount(query)
    },
    onFormSubmit(values: FormValues) {
      const query = this.convertFormValues(values)
      this.isSubmitted = true

      // 検索状態をstoreに保存
      this.$store.commit(updateSearchConditions(query))

      // 検索状態を永続化する
      this.$store.commit(saveConditions())

      // @ts-ignore
      this.$router.push({ path: '/programs', query })
      this.$modal.pop()
    },
    modalHeaderClose(): void {
      if (!this.isSubmitted) {
        this.isDirectAccess ? this.$router.push('/') : this.$router.go(-1)
      }
    },
  },
})
